module.exports = __webpack_public_path__ + "img/saoma.3e8e249a.png";